const convertToLocalTime = (utcDateString: string, style: 'DD/MM/YYYY' | 'YYYY-MM-DD' = 'YYYY-MM-DD'): string => {
  const utcDate = new Date(utcDateString);
  const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  if (style === 'DD/MM/YYYY') {
    const day = String(localDate.getDate()).padStart(2, '0');
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const year = localDate.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return localDate.toISOString().slice(0, 19).replace('T', ' ');
};
export { convertToLocalTime };